<script setup lang="ts">
import { ref } from 'vue';
import { useForm } from 'vee-validate';
import MarketingDetailViewForm from '@apparatix/leads/MarketingDetailViewForm.vue';
import DetailEditorControls from '@apparatix/library/DetailEditorControls.vue';
import { useOpportunities } from '@apparatix/composables';
import type { OpportunityType, RevenueData } from '@apparatix/types/Leads.ts';


type Props = {
  type: OpportunityType;
  opportunityId: number;
  revenueData: RevenueData;
  canViewAudience: boolean;
};

const props = defineProps<Props>();
const { getAudienceSelectionUrl, getGeoSelectionUrl } = useOpportunities();

const audienceSelectionUrl = ref(
  getAudienceSelectionUrl(props.opportunityId),
);

const geoSelectionUrl = ref(
  getGeoSelectionUrl(props.opportunityId),
);

const {
  errors: detailEditorErrors, values: detailEditorModel,
} = useForm({
  initialValues: {
  },
});
</script>
<template>
  <DetailEditorControls
    :header="props.canViewAudience ? 'Inventory and Demographics' : 'Inventory'"
    :hide-button="true"
  >
    <MarketingDetailViewForm
      :type="props.type"
      :is-converting-lead="false"
      :audience-selection-url="audienceSelectionUrl"
      :geo-selection-url="geoSelectionUrl"
      :audience-selection-value="props.revenueData?.audience"
      :geo-selection-value="props.revenueData?.inventoryArea"
      :marketing-details="detailEditorModel"
      :errors="detailEditorErrors"
    />
  </DetailEditorControls>
</template>
